import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  ntypid: number;
  active?: boolean;
  allow_in_app?: boolean;
  allow_email?: boolean;
  allow_sms?: boolean;
  default_in_app?: boolean;
  default_email?: boolean;
  default_sms?: boolean;
};

type MutationResponse = {
  status: number;
  data: Record<string, unknown>;
};

export const useUpdateNotificationTypeMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while updating the notification type',
    endpoint: ({ ntypid }) => `/api/admin/notifications/type/${ntypid}`,
    method: 'PATCH',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
